<ticketing-draw-item-container [draw]="draw()">
  @switch (draw().state) {
    @case (DrawState.RegistrationOpen) {
      <ticketing-button
        appearance="primary"
        [routerLink]="['/draws', draw().id, 'register']"
      >
        <div class="flex mx-1 my-0.5">
          @if (draw().registration; as registration) {
            @if (registration.state === RegistrationState.Submitted) {
              <div class="mr-2">Registrierung ansehen</div>
            } @else {
              <div class="mr-2">Registrierung fortsetzen</div>
            }
          } @else {
            <div class="mr-2">Registrierung starten</div>
          }
          <fa-icon
            class="place-self-center"
            [icon]="faArrowRight"
            size="sm"
          />
        </div>
      </ticketing-button>
    }
    @case (DrawState.Drawn) {
      <ticketing-button
        appearance="primary"
        [routerLink]="['/draws', draw().id, 'register', 'results']"
      >
        <div class="flex mx-1 my-0.5">
          <div class="mr-2">Zum Ergebnis</div>
          <fa-icon
            [icon]="faArrowRight"
            size="sm"
          />
        </div>
      </ticketing-button>
    }
  }
</ticketing-draw-item-container>
